// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { FaArrowLeft, FaTrash, FaPlus } from "react-icons/fa";
// import Swal from "sweetalert2";

// const API_BASE = "https://backend.vfarmstays.com/api";

// const initialForm = {
//   name: "",
//   address: "",
//   description: "",
//   amenities: "",
//   lat: "",
//   lng: "",
//   price: "",
//   active: true,
//   bookingFor: "",
//   rating: "",
//   noOfPersons: "",
// };

// const FarmhouseForm = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const isEditMode = Boolean(id);

//   const [form, setForm] = useState(initialForm);
//   const [images, setImages] = useState([]);
//   const [existingImages, setExistingImages] = useState([]);
//   const [video, setVideo] = useState(null);
//   const [existingVideo, setExistingVideo] = useState("");
//   const [timePrices, setTimePrices] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [weeklySchedule, setWeeklySchedule] = useState([]);


//   /* ================= FORMAT TIME (24h → 12h AM/PM) ================= */
//   const formatTime = (time) => {
//     if (!time) return "";
//     const [hour, minute] = time.split(":");
//     const h = parseInt(hour);
//     const ampm = h >= 12 ? "PM" : "AM";
//     const formattedHour = h % 12 || 12;
//     return `${formattedHour}:${minute} ${ampm}`;
//   };

//   /* ================= PARSE TIME (12h AM/PM → 24h) ================= */
//   const parseTime = (timeStr) => {
//     if (!timeStr) return "";
//     const trimmed = timeStr.trim();
//     const [time, modifier] = trimmed.split(" ");
//     if (!time || !modifier) return "";

//     let [hour, minute] = time.split(":").map(Number);

//     if (modifier.toUpperCase() === "PM" && hour !== 12) {
//       hour += 12;
//     }
//     if (modifier.toUpperCase() === "AM" && hour === 12) {
//       hour = 0;
//     }

//     return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
//   };

//   /* ================= FETCH FOR EDIT ================= */
//   useEffect(() => {
//     if (!isEditMode) return;

//     const fetchData = async () => {
//       try {
//         Swal.fire({
//           title: "Loading...",
//           allowOutsideClick: false,
//           didOpen: () => Swal.showLoading(),
//         });

//         const res = await axios.get(`${API_BASE}/farmhouse/${id}`);
//         const f = res.data.farmhouse;

//         setForm({
//           name: f.name || "",
//           address: f.address || "",
//           description: f.description || "",
//           amenities: f.amenities?.join(",") || "",
//           lat: f.location?.coordinates?.[1] || "",
//           lng: f.location?.coordinates?.[0] || "",
//           price: f.price || "",
//           active: f.active ?? true,
//           bookingFor: f.bookingFor || "",
//           rating: f.rating || "",
//           noOfPersons: f.noOfPersons || "",
//         });

//         setExistingImages(f.images || []);
//         setExistingVideo(f.video || "");

//         // Parse timePrices: split "9:00 AM - 12:00 PM" → start/end in 24h format
//         setTimePrices(
//           f.timePrices?.map((tp) => {
//             const [startRaw, endRaw] = tp.timing?.split(" - ") || ["", ""];
//             return {
//               label: tp.label || "",
//               start: parseTime(startRaw),
//               end: parseTime(endRaw),
//               price: tp.price || "",  // ← parse existing price
//             };
//           }) || []
//         );

//         Swal.close();
//       } catch (err) {
//         console.error("Fetch error:", err);
//         Swal.fire("Error", "Failed to load farmhouse", "error");
//       }
//     };

//     fetchData();
//   }, [id, isEditMode]);

//   /* ================= HANDLERS ================= */

//   const handleChange = (e) =>
//     setForm({ ...form, [e.target.name]: e.target.value });

//   const addTimePrice = () =>
//     setTimePrices([...timePrices, { label: "", start: "", end: "", price: "" }]);  // ← added price

//   const updateTimePrice = (index, key, value) => {
//     const updated = [...timePrices];
//     updated[index][key] = value;
//     setTimePrices(updated);
//   };

//   const removeTimePrice = (index) => {
//     setTimePrices(timePrices.filter((_, i) => i !== index));
//   };

//   /* ================= SUBMIT ================= */

//   const handleSubmit = async () => {
//     try {
//       setLoading(true);

//       Swal.fire({
//         title: isEditMode ? "Updating..." : "Creating...",
//         allowOutsideClick: false,
//         didOpen: () => Swal.showLoading(),
//       });

//       const fd = new FormData();

//       fd.append("name", form.name);
//       fd.append("address", form.address);
//       fd.append("description", form.description);
//       fd.append("amenities", form.amenities);
//       fd.append("lat", form.lat);
//       fd.append("lng", form.lng);
//       fd.append("price", form.price);
//       fd.append("active", form.active);
//       fd.append("bookingFor", form.bookingFor);
//       fd.append("rating", form.rating);
//       fd.append("noOfPersons", form.noOfPersons);

//       const formattedTimePrices = timePrices
//         .filter((tp) => tp.label && tp.start && tp.end)  // Only send complete slots
//         .map((tp) => ({
//           label: tp.label,
//           timing: `${formatTime(tp.start)} - ${formatTime(tp.end)}`,
//           price: tp.price,  // ← include price in payload
//         }));

//       fd.append("timePrices", JSON.stringify(formattedTimePrices));

//       images.forEach((img) => {
//         fd.append("images", img);
//       });

//       if (video) {
//         fd.append("video", video);
//       }

//       const config = {
//         headers: { "Content-Type": "multipart/form-data" },
//       };

//       if (isEditMode) {
//         await axios.put(`${API_BASE}/farmhouse/${id}`, fd, config);
//       } else {
//         await axios.post(`${API_BASE}/farmhouse-create`, fd, config);
//       }

//       Swal.fire("Success", "Farmhouse saved successfully!", "success");
//       navigate("/admin/farmhouses");
//     } catch (err) {
//       console.error("Submit error:", err);
//       Swal.fire(
//         "Error",
//         err?.response?.data?.message || "Something went wrong",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen px-4 sm:px-6 lg:px-10 py-10 bg-gradient-to-br from-amber-50 via-lime-50 to-amber-100">
//       <div className="max-w-6xl mx-auto bg-white/90 backdrop-blur-xl p-6 sm:p-8 rounded-3xl shadow-2xl border border-amber-200">

//         {/* HEADER */}
//         <button
//           onClick={() => navigate(-1)}
//           className="flex items-center gap-2 mb-6 px-4 py-2 rounded-xl font-semibold
//           bg-gradient-to-r from-amber-500 to-lime-500 text-white shadow-lg hover:scale-105 transition"
//         >
//           <FaArrowLeft /> Back
//         </button>

//         <h2 className="text-3xl sm:text-4xl font-bold mb-8 bg-gradient-to-r from-amber-600 to-lime-600 bg-clip-text text-transparent">
//           {isEditMode ? "Edit Farmhouse" : "Create Farmhouse"}
//         </h2>

//         {/* FORM GRID */}
//         <div className="grid sm:grid-cols-2 gap-6">
//           {Object.keys(initialForm).map((key) => (
//             <div key={key} className="flex flex-col gap-2">
//               <label className="font-semibold capitalize text-amber-700">
//                 {
//                   key === "noOfPersons"
//                     ? "Number of Persons"
//                     : key === "price"
//                       ? "Day Price"
//                       : key
//                 }
//               </label>

//               {key === "active" ? (
//                 <select
//                   name="active"
//                   value={form.active}
//                   onChange={(e) =>
//                     setForm({ ...form, active: e.target.value === "true" })
//                   }
//                   className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
//                 >
//                   <option value="true">Active</option>
//                   <option value="false">Inactive</option>
//                 </select>
//               ) : key === "rating" ? (
//                 <select
//                   name="rating"
//                   value={form.rating}
//                   onChange={handleChange}
//                   className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
//                 >
//                   <option value="">Select Rating</option>
//                   <option value="1">1 Star</option>
//                   <option value="1.5">1.5 Stars</option>
//                   <option value="2">2 Stars</option>
//                   <option value="2.5">2.5 Stars</option>
//                   <option value="3">3 Stars</option>
//                   <option value="3.5">3.5 Stars</option>
//                   <option value="4">4 Stars</option>
//                   <option value="4.5">4.5 Stars</option>
//                   <option value="5">5 Stars</option>
//                 </select>
//               ) : key === "bookingFor" ? (
//                 <select
//                   name="bookingFor"
//                   value={form.bookingFor}
//                   onChange={handleChange}
//                   className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
//                 >
//                   <option value="">Select Booking Type</option>
//                   <option value="Family">Family</option>
//                   <option value="Couple">Couple</option>
//                   <option value="Friends">Friends</option>
//                   <option value="Corporate">Corporate</option>
//                 </select>
//               ) : key === "noOfPersons" ? (
//                 <input
//                   name={key}
//                   type="number"
//                   value={form[key]}
//                   onChange={handleChange}
//                   className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
//                   placeholder="Enter maximum persons"
//                 />
//               ) : (
//                 <input
//                   name={key}
//                   value={form[key]}
//                   onChange={handleChange}
//                   className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
//                 />
//               )}
//             </div>
//           ))}
//         </div>

//         {/* IMAGE UPLOAD */}
//         <div className="mt-10">
//           <label className="font-semibold text-amber-700">Upload Images</label>
//           <input
//             type="file"
//             multiple
//             accept="image/*"
//             onChange={(e) => setImages([...e.target.files])}
//             className="mt-3 w-full border-2 border-dashed border-lime-400 p-4 rounded-xl bg-lime-50"
//           />

//           {isEditMode && existingImages.length > 0 && (
//             <div className="mt-4">
//               <p className="text-sm text-amber-700 mb-2">Existing Images:</p>
//               <div className="flex flex-wrap gap-2">
//                 {existingImages.map((img, idx) => (
//                   <img
//                     key={idx}
//                     src={img.trim()}
//                     alt={`Existing ${idx + 1}`}
//                     className="w-20 h-20 object-cover rounded-lg border border-amber-200"
//                   />
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>

//         {/* VIDEO UPLOAD */}
//         <div className="mt-10">
//           <label className="font-semibold text-amber-700">
//             Upload Video (Optional)
//           </label>
//           <input
//             type="file"
//             accept="video/*"
//             onChange={(e) => setVideo(e.target.files[0])}
//             className="mt-3 w-full border-2 border-dashed border-lime-400 p-4 rounded-xl bg-lime-50"
//           />

//           {isEditMode && existingVideo && (
//             <div className="mt-4">
//               <p className="text-sm text-amber-700 mb-2">Existing Video:</p>
//               <video
//                 src={existingVideo}
//                 controls
//                 className="w-64 rounded-lg border border-amber-200"
//               />
//             </div>
//           )}
//         </div>

//         {/* TIME SLOTS */}
//         <div className="mt-12">
//           <div className="flex justify-between items-center mb-6">
//             <h3 className="text-xl font-bold text-amber-700">Time Slots</h3>
//             <button
//               onClick={addTimePrice}
//               className="flex items-center gap-2 px-4 py-2 rounded-xl
//               bg-gradient-to-r from-amber-500 to-lime-500 text-white shadow-lg hover:scale-105 transition"
//             >
//               <FaPlus /> Add Slot
//             </button>
//           </div>

//           {timePrices.map((tp, i) => (
//             <div
//               key={i}
//               className="grid sm:grid-cols-5 gap-4 mb-4 p-4 rounded-2xl border border-amber-200 bg-lime-50"
//             >
//               <input
//                 value={tp.label}
//                 onChange={(e) => updateTimePrice(i, "label", e.target.value)}
//                 placeholder="Label (e.g., Morning)"
//                 className="p-3 rounded-xl border border-amber-300"
//               />

//               <input
//                 type="time"
//                 value={tp.start}
//                 onChange={(e) => updateTimePrice(i, "start", e.target.value)}
//                 className="p-3 rounded-xl border border-amber-300"
//               />

//               <input
//                 type="time"
//                 value={tp.end}
//                 onChange={(e) => updateTimePrice(i, "end", e.target.value)}
//                 className="p-3 rounded-xl border border-amber-300"
//               />

//               {/* ← NEW PRICE FIELD */}
//               <input
//                 type="number"
//                 value={tp.price}
//                 onChange={(e) => updateTimePrice(i, "price", e.target.value)}
//                 placeholder="Price (₹)"
//                 className="p-3 rounded-xl border border-amber-300"
//               />

//               <button
//                 onClick={() => removeTimePrice(i)}
//                 className="bg-red-500 text-white rounded-xl flex justify-center items-center hover:bg-red-600 transition"
//                 title="Remove slot"
//               >
//                 <FaTrash />
//               </button>
//             </div>
//           ))}

//           {timePrices.length === 0 && (
//             <p className="text-amber-600 text-sm italic">
//               No time slots added yet.
//             </p>
//           )}
//         </div>

//         {/* SUBMIT */}
//         <div className="mt-10 flex justify-end">
//           <button
//             disabled={loading}
//             onClick={handleSubmit}
//             className="px-8 py-3 rounded-xl font-bold text-white
//             bg-gradient-to-r from-amber-500 to-lime-600
//             hover:scale-105 transition shadow-xl disabled:opacity-50 disabled:hover:scale-100"
//           >
//             {loading ? "Saving..." : "Submit"}
//           </button>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default FarmhouseForm;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft, FaTrash, FaPlus, FaTimes } from "react-icons/fa";
import Swal from "sweetalert2";

const API_BASE = "https://backend.vfarmstays.com/api";

const initialForm = {
  name: "",
  address: "",
  description: "",
  amenities: "",
  lat: "",
  lng: "",
  price: "",
  active: true,
  bookingFor: "",
  rating: "",
  noOfPersons: "",
};

// ✅ Days of the week
const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const FarmhouseForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = Boolean(id);

  const [form, setForm] = useState(initialForm);
  const [images, setImages] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [video, setVideo] = useState(null);
  const [existingVideo, setExistingVideo] = useState("");
  
  const [weeklySchedule, setWeeklySchedule] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= FORMAT TIME (24h → 12h AM/PM) ================= */
  const formatTime = (time) => {
    if (!time) return "";
    const [hour, minute] = time.split(":");
    const h = parseInt(hour);
    const ampm = h >= 12 ? "PM" : "AM";
    const formattedHour = h % 12 || 12;
    return `${formattedHour}:${minute} ${ampm}`;
  };

  /* ================= PARSE TIME (12h AM/PM → 24h) ================= */
  const parseTime = (timeStr) => {
    if (!timeStr) return "";
    const trimmed = timeStr.trim();
    const [time, modifier] = trimmed.split(" ");
    if (!time || !modifier) return "";

    let [hour, minute] = time.split(":").map(Number);

    if (modifier.toUpperCase() === "PM" && hour !== 12) {
      hour += 12;
    }
    if (modifier.toUpperCase() === "AM" && hour === 12) {
      hour = 0;
    }

    return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
  };

  /* ================= FETCH FOR EDIT ================= */
  useEffect(() => {
    if (!isEditMode) {
      setWeeklySchedule(DAYS.map(day => ({
        day,
        isActive: true,
        slots: [{ label: "", start: "", end: "", price: "", maxBookings: 1 }]
      })));
      return;
    }

    const fetchData = async () => {
      try {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        const res = await axios.get(`${API_BASE}/farmhouse/${id}`);
        const f = res.data.farmhouse;

        setForm({
          name: f.name || "",
          address: f.address || "",
          description: f.description || "",
          amenities: f.amenities?.join(",") || "",
          lat: f.location?.coordinates?.[1] || "",
          lng: f.location?.coordinates?.[0] || "",
          price: f.price || "",
          active: f.active ?? true,
          bookingFor: f.bookingFor || "",
          rating: f.rating || "",
          noOfPersons: f.noOfPersons || "",
        });

        setExistingImages(f.images || []);
        setExistingVideo(f.video || "");

        if (f.weeklySchedule && f.weeklySchedule.length > 0) {
          const parsedSchedule = f.weeklySchedule.map(day => ({
            day: day.day || "Monday",
            isActive: day.isActive !== undefined ? day.isActive : true,
            slots: day.slots?.map(slot => ({
              label: slot.label || "",
              start: parseTime(slot.timing?.split(" - ")[0] || ""),
              end: parseTime(slot.timing?.split(" - ")[1] || ""),
              price: slot.price || "",
              maxBookings: slot.maxBookings || 1,
            })) || [{ label: "", start: "", end: "", price: "", maxBookings: 1 }]
          }));
          setWeeklySchedule(parsedSchedule);
        } else {
          setWeeklySchedule(DAYS.map(day => ({
            day,
            isActive: true,
            slots: [{ label: "", start: "", end: "", price: "", maxBookings: 1 }]
          })));
        }

        Swal.close();
      } catch (err) {
        console.error("Fetch error:", err);
        Swal.fire("Error", "Failed to load farmhouse", "error");
      }
    };

    fetchData();
  }, [id, isEditMode]);

  /* ================= HANDLERS ================= */

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ✅ Handle multiple image selection - FIXED
  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      // ✅ Append new files to existing ones (don't replace)
      setImages(prev => [...prev, ...files]);
      console.log(`📸 Added ${files.length} images. Total: ${images.length + files.length}`);
    }
    // Reset input to allow selecting same file again
    e.target.value = null;
  };

  // ✅ Remove image from selected list
  const removeSelectedImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const addSlotToDay = (dayIndex) => {
    const updated = [...weeklySchedule];
    if (!updated[dayIndex]) {
      updated[dayIndex] = { day: DAYS[dayIndex], isActive: true, slots: [] };
    }
    updated[dayIndex].slots.push({
      label: "",
      start: "",
      end: "",
      price: "",
      maxBookings: 1
    });
    setWeeklySchedule(updated);
  };

  const updateSlot = (dayIndex, slotIndex, key, value) => {
    const updated = [...weeklySchedule];
    updated[dayIndex].slots[slotIndex][key] = value;
    setWeeklySchedule(updated);
  };

  const removeSlot = (dayIndex, slotIndex) => {
    const updated = [...weeklySchedule];
    updated[dayIndex].slots = updated[dayIndex].slots.filter((_, i) => i !== slotIndex);
    if (updated[dayIndex].slots.length === 0) {
      updated[dayIndex].slots.push({ label: "", start: "", end: "", price: "", maxBookings: 1 });
    }
    setWeeklySchedule(updated);
  };

  const toggleDayActive = (dayIndex) => {
    const updated = [...weeklySchedule];
    if (updated[dayIndex]) {
      updated[dayIndex].isActive = !updated[dayIndex].isActive;
      setWeeklySchedule(updated);
    }
  };

  const resetSchedule = () => {
    setWeeklySchedule(DAYS.map(day => ({
      day,
      isActive: true,
      slots: [{ label: "", start: "", end: "", price: "", maxBookings: 1 }]
    })));
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async () => {
    try {
      setLoading(true);

      Swal.fire({
        title: isEditMode ? "Updating..." : "Creating...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const fd = new FormData();

      fd.append("name", form.name);
      fd.append("address", form.address);
      fd.append("description", form.description);
      fd.append("amenities", form.amenities);
      fd.append("lat", form.lat);
      fd.append("lng", form.lng);
      fd.append("price", form.price);
      fd.append("active", form.active);
      fd.append("bookingFor", form.bookingFor);
      fd.append("rating", form.rating);
      fd.append("noOfPersons", form.noOfPersons);

      // Build weeklySchedule payload
      const formattedSchedule = weeklySchedule
        .filter(day => day.slots?.some(slot => slot.label && slot.start && slot.end))
        .map(day => ({
          day: day.day,
          isActive: day.isActive !== undefined ? day.isActive : true,
          slots: day.slots
            .filter(slot => slot.label && slot.start && slot.end)
            .map(slot => ({
              label: slot.label.trim(),
              timing: `${formatTime(slot.start)} - ${formatTime(slot.end)}`,
              price: Number(slot.price) || 0,
              maxBookings: Number(slot.maxBookings) || 1,
            }))
        }))
        .filter(day => day.slots.length > 0);

      fd.append("weeklySchedule", JSON.stringify(formattedSchedule));

      // ✅ FIX: Append ALL images with key 'images'
      if (images && images.length > 0) {
        console.log(`📸 Uploading ${images.length} images...`);
        images.forEach((img, index) => {
          fd.append('images', img);
          console.log(`  📸 Image ${index + 1}: ${img.name} (${img.size} bytes)`);
        });
      } else {
        console.log("⚠️ No images selected");
      }

      if (video) {
        fd.append("video", video);
        console.log(`🎬 Uploading video: ${video.name}`);
      }

      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      let response;
      if (isEditMode) {
        response = await axios.put(`${API_BASE}/farmhouse/${id}`, fd, config);
      } else {
        response = await axios.post(`${API_BASE}/farmhouse-create`, fd, config);
      }

      console.log("✅ Response:", response.data);
      
      if (response.data.uploadSummary) {
        console.log(`📸 Images uploaded: ${response.data.uploadSummary.imagesUploaded}`);
      }

      Swal.fire("Success", "Farmhouse saved successfully!", "success");
      navigate("/admin/farmhouses");
    } catch (err) {
      console.error("❌ Submit error:", err);
      Swal.fire(
        "Error",
        err?.response?.data?.message || err?.message || "Something went wrong",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen px-4 sm:px-6 lg:px-10 py-10 bg-gradient-to-br from-amber-50 via-lime-50 to-amber-100">
      <div className="max-w-6xl mx-auto bg-white/90 backdrop-blur-xl p-6 sm:p-8 rounded-3xl shadow-2xl border border-amber-200">

        {/* HEADER */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 mb-6 px-4 py-2 rounded-xl font-semibold
          bg-gradient-to-r from-amber-500 to-lime-500 text-white shadow-lg hover:scale-105 transition"
        >
          <FaArrowLeft /> Back
        </button>

        <h2 className="text-3xl sm:text-4xl font-bold mb-8 bg-gradient-to-r from-amber-600 to-lime-600 bg-clip-text text-transparent">
          {isEditMode ? "Edit Farmhouse" : "Create Farmhouse"}
        </h2>

        {/* FORM GRID */}
        <div className="grid sm:grid-cols-2 gap-6">
          {Object.keys(initialForm).map((key) => (
            <div key={key} className="flex flex-col gap-2">
              <label className="font-semibold capitalize text-amber-700">
                {key === "noOfPersons" 
                  ? "Number of Persons" 
                  : key === "price" 
                    ? "Display Price" 
                    : key}
              </label>

              {key === "active" ? (
                <select
                  name="active"
                  value={form.active}
                  onChange={(e) =>
                    setForm({ ...form, active: e.target.value === "true" })
                  }
                  className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              ) : key === "rating" ? (
                <select
                  name="rating"
                  value={form.rating}
                  onChange={handleChange}
                  className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
                >
                  <option value="">Select Rating</option>
                  <option value="1">1 Star</option>
                  <option value="1.5">1.5 Stars</option>
                  <option value="2">2 Stars</option>
                  <option value="2.5">2.5 Stars</option>
                  <option value="3">3 Stars</option>
                  <option value="3.5">3.5 Stars</option>
                  <option value="4">4 Stars</option>
                  <option value="4.5">4.5 Stars</option>
                  <option value="5">5 Stars</option>
                </select>
              ) : key === "bookingFor" ? (
                <select
                  name="bookingFor"
                  value={form.bookingFor}
                  onChange={handleChange}
                  className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
                >
                  <option value="">Select Booking Type</option>
                  <option value="Family">Family</option>
                  <option value="Couple">Couple</option>
                  <option value="Friends">Friends</option>
                  <option value="Corporate">Corporate</option>
                </select>
              ) : key === "noOfPersons" ? (
                <input
                  name={key}
                  type="number"
                  value={form[key]}
                  onChange={handleChange}
                  className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
                  placeholder="Enter maximum persons"
                />
              ) : (
                <input
                  name={key}
                  value={form[key]}
                  onChange={handleChange}
                  className="p-3 border border-amber-300 rounded-xl focus:ring-2 focus:ring-lime-400 outline-none"
                />
              )}
            </div>
          ))}
        </div>

        {/* IMAGE UPLOAD - FIXED: Multiple image selection */}
        <div className="mt-10">
          <label className="font-semibold text-amber-700">Upload Images</label>
          
          {/* ✅ Show upload button with counter */}
          <div className="flex items-center gap-4 mt-3">
            <input
              type="file"
              multiple
              accept="image/*"
              onChange={handleImageSelect}
              className="w-full border-2 border-dashed border-lime-400 p-4 rounded-xl bg-lime-50"
            />
            {images.length > 0 && (
              <span className="bg-amber-500 text-white px-3 py-1 rounded-full text-sm whitespace-nowrap">
                {images.length} selected
              </span>
            )}
          </div>

          {/* ✅ Show selected images preview */}
          {images.length > 0 && (
            <div className="mt-4">
              <p className="text-sm text-amber-700 mb-2">Selected Images ({images.length}):</p>
              <div className="flex flex-wrap gap-2">
                {images.map((img, idx) => (
                  <div key={idx} className="relative group">
                    <img
                      src={URL.createObjectURL(img)}
                      alt={`Selected ${idx + 1}`}
                      className="w-20 h-20 object-cover rounded-lg border border-amber-200"
                    />
                    <button
                      onClick={() => removeSelectedImage(idx)}
                      className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600 transition opacity-0 group-hover:opacity-100"
                    >
                      <FaTimes size={10} />
                    </button>
                    <span className="absolute bottom-0 left-0 right-0 bg-black/50 text-white text-[10px] text-center truncate px-1 rounded-b-lg">
                      {img.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {isEditMode && existingImages.length > 0 && (
            <div className="mt-4">
              <p className="text-sm text-amber-700 mb-2">Existing Images:</p>
              <div className="flex flex-wrap gap-2">
                {existingImages.map((img, idx) => (
                  <img
                    key={idx}
                    src={img.trim()}
                    alt={`Existing ${idx + 1}`}
                    className="w-20 h-20 object-cover rounded-lg border border-amber-200"
                  />
                ))}
              </div>
            </div>
          )}
        </div>

        {/* VIDEO UPLOAD */}
        <div className="mt-10">
          <label className="font-semibold text-amber-700">
            Upload Video (Optional)
          </label>
          <input
            type="file"
            accept="video/*"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                setVideo(file);
                console.log(`🎬 Selected video: ${file.name} (${file.size} bytes)`);
              }
            }}
            className="mt-3 w-full border-2 border-dashed border-lime-400 p-4 rounded-xl bg-lime-50"
          />

          {video && (
            <div className="mt-3">
              <p className="text-sm text-green-600">✅ Video selected: {video.name}</p>
            </div>
          )}

          {isEditMode && existingVideo && (
            <div className="mt-4">
              <p className="text-sm text-amber-700 mb-2">Existing Video:</p>
              <video
                src={existingVideo}
                controls
                className="w-64 rounded-lg border border-amber-200"
              />
            </div>
          )}
        </div>

        {/* WEEKLY SCHEDULE SECTION */}
        <div className="mt-12">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-xl font-bold text-amber-700">Weekly Schedule</h3>
            <button
              onClick={resetSchedule}
              className="flex items-center gap-2 px-4 py-2 rounded-xl
              bg-gradient-to-r from-gray-500 to-gray-700 text-white shadow-lg hover:scale-105 transition"
            >
              Reset All Days
            </button>
          </div>

          {weeklySchedule.map((dayData, dayIndex) => (
            <div key={dayData.day || dayIndex} className="mb-6 p-4 rounded-2xl border border-amber-200 bg-lime-50">
              {/* Day Header */}
              <div className="flex justify-between items-center mb-3">
                <div className="flex items-center gap-4">
                  <h4 className="text-lg font-bold text-amber-800">{dayData.day}</h4>
                  <button
                    onClick={() => toggleDayActive(dayIndex)}
                    className={`px-3 py-1 rounded-full text-sm ${
                      dayData.isActive !== false 
                        ? 'bg-green-500 text-white' 
                        : 'bg-gray-400 text-white'
                    }`}
                  >
                    {dayData.isActive !== false ? 'Active' : 'Inactive'}
                  </button>
                </div>
                <button
                  onClick={() => addSlotToDay(dayIndex)}
                  className="flex items-center gap-2 px-3 py-1 rounded-lg
                  bg-gradient-to-r from-amber-500 to-lime-500 text-white text-sm shadow hover:scale-105 transition"
                >
                  <FaPlus size={12} /> Add Slot
                </button>
              </div>

              {/* Slots for this day */}
              {dayData.slots && dayData.slots.length > 0 ? (
                dayData.slots.map((slot, slotIndex) => (
                  <div
                    key={slotIndex}
                    className="grid grid-cols-1 sm:grid-cols-6 gap-3 mb-3 p-3 rounded-xl bg-white border border-amber-200"
                  >
                    <input
                      value={slot.label}
                      onChange={(e) => updateSlot(dayIndex, slotIndex, "label", e.target.value)}
                      placeholder="Label"
                      className="p-2 rounded-lg border border-amber-300 focus:ring-2 focus:ring-lime-400 outline-none text-sm"
                    />

                    <input
                      type="time"
                      value={slot.start}
                      onChange={(e) => updateSlot(dayIndex, slotIndex, "start", e.target.value)}
                      className="p-2 rounded-lg border border-amber-300 focus:ring-2 focus:ring-lime-400 outline-none text-sm"
                    />

                    <input
                      type="time"
                      value={slot.end}
                      onChange={(e) => updateSlot(dayIndex, slotIndex, "end", e.target.value)}
                      className="p-2 rounded-lg border border-amber-300 focus:ring-2 focus:ring-lime-400 outline-none text-sm"
                    />

                    <input
                      type="number"
                      value={slot.price}
                      onChange={(e) => updateSlot(dayIndex, slotIndex, "price", e.target.value)}
                      placeholder="Price (₹)"
                      className="p-2 rounded-lg border border-amber-300 focus:ring-2 focus:ring-lime-400 outline-none text-sm"
                    />

                    <input
                      type="number"
                      value={slot.maxBookings || 1}
                      onChange={(e) => updateSlot(dayIndex, slotIndex, "maxBookings", e.target.value)}
                      placeholder="Max Bookings"
                      className="p-2 rounded-lg border border-amber-300 focus:ring-2 focus:ring-lime-400 outline-none text-sm"
                      min="1"
                    />

                    <button
                      onClick={() => removeSlot(dayIndex, slotIndex)}
                      className="bg-red-500 text-white rounded-lg flex justify-center items-center hover:bg-red-600 transition p-2"
                      title="Remove slot"
                    >
                      <FaTrash />
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-amber-600 text-sm italic">No slots added for this day</p>
              )}
            </div>
          ))}
        </div>

        {/* SUBMIT */}
        <div className="mt-10 flex justify-end">
          <button
            disabled={loading}
            onClick={handleSubmit}
            className="px-8 py-3 rounded-xl font-bold text-white
            bg-gradient-to-r from-amber-500 to-lime-600
            hover:scale-105 transition shadow-xl disabled:opacity-50 disabled:hover:scale-100"
          >
            {loading ? "Saving..." : "Submit"}
          </button>
        </div>

      </div>
    </div>
  );
};


export default FarmhouseForm;